import "./style.css";
import logo from "@/src/assets/images/logo.webp";
import Link from "next/link";
import { useEffect, useState } from "react";
import CountUp from "react-countup";

const CustomHeader = ({ design_2 = false }) => {
	const [loaded, setLoaded] = useState(false);

	const [currentTime, setCurrentTime] = useState("");
	const [yearLeft, setYearLeft] = useState("");
	const targetDate = new Date("2029-07-22T16:00:00+00:00");

	useEffect(() => {
		setLoaded(true);
	}, []);
	const [isDropdownOpened, setDropdownOpened] = useState(false);
	const [dropdownClasses, setDropdownClasses] = useState("");
	function openDropdown() {
		setDropdownClasses("opened");
		setDropdownOpened(true);
	}

	function closeDropdown() {
		setDropdownClasses("opened closing");
		setTimeout(() => {
			setDropdownOpened(false);
			setDropdownClasses("");
		}, 1000);
	}

	useEffect(() => {
		const updateTimer = () => {
			const currentTime = new Date().toLocaleString("en-US", {
				timeZone: "Asia/Kolkata",
			});
			const difference = targetDate - new Date(currentTime);

			// If the count down is over
			if (difference < 0) {
				setTimeLeft("Countdown finished");
				setYearLeft(0);
				setCurrentTime("");
				return;
			}

			let time = difference / 1000;
			const days = Math.floor(time / (3600 * 24));
			setYearLeft(days / 365);
			time -= days * 3600 * 24;
			const hours = Math.floor(time / 3600);
			time -= hours * 3600;
			const minutes = Math.floor(time / 60);
			const seconds = Math.floor(time % 60);

			setCurrentTime(`${hours}:${minutes}:${seconds}`);
		};

		// Update the timer every second
		const timerId = setInterval(updateTimer, 1000);

		// Cleanup the interval on component unmount
		return () => clearInterval(timerId);
	}, [targetDate]);

	return (
		<>
			<div className="floating_div">
				<div className="hidden_content">
					<p className="floating_div_title">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={29}
							height={29}
							viewBox="0 0 29 29"
							fill="none"
						>
							<g clipPath="url(#clip0_1661_3117)">
								<path
									d="M26.6949 7.08009C26.5328 6.85303 26.2873 6.6963 26.0099 6.64278C25.7324 6.58926 25.4446 6.64311 25.2068 6.79303C24.969 6.94296 24.7997 7.1773 24.7345 7.44687C24.6693 7.71645 24.7131 8.0003 24.8569 8.23886C25.2201 8.78968 25.5359 9.36909 25.8012 9.97112C25.9165 10.2315 26.1327 10.4363 26.4021 10.5406C26.6716 10.6448 26.9723 10.6399 27.2381 10.5269C27.5038 10.4139 27.7129 10.2021 27.8193 9.93813C27.9257 9.67413 27.9207 9.37953 27.8053 9.11915C27.4933 8.41057 27.1219 7.72854 26.6949 7.08009ZM24.7943 3.86809C24.8391 3.98714 24.8659 4.11197 24.8738 4.23862C24.9196 4.52272 24.859 4.81348 24.7032 5.05724C24.5473 5.30101 24.3068 5.48133 24.0259 5.56495L20.7812 6.542C20.4729 6.63338 20.1402 6.60106 19.8563 6.45212C19.5724 6.30319 19.3605 6.04986 19.2672 5.74785C19.1739 5.44585 19.2069 5.11991 19.3589 4.84174C19.511 4.56357 19.7695 4.35596 20.0778 4.26458L20.3861 4.17253C19.6071 3.75628 18.784 3.4247 17.9315 3.18368C16.236 2.70257 14.4549 2.58385 12.7085 2.83554C10.9621 3.08724 9.29133 3.70348 7.8091 4.64258C6.32687 5.58168 5.0678 6.82173 4.11707 8.27884C3.16634 9.73595 2.54613 11.3761 2.2984 13.0884C2.05067 14.8007 2.1812 16.5451 2.68116 18.2037C3.18112 19.8622 4.03884 21.3962 5.1963 22.7019C6.35376 24.0076 7.78396 25.0545 9.39013 25.7718C10.9963 26.4891 12.741 26.86 14.5061 26.8595C14.8337 26.8595 15.1324 26.8595 15.4697 26.8288C15.933 26.797 16.3939 26.7379 16.8499 26.6518C16.9937 26.6183 17.1429 26.6136 17.2885 26.6381C17.4342 26.6627 17.5732 26.7159 17.6973 26.7945C17.8214 26.8732 17.9279 26.9756 18.0104 27.0957C18.0929 27.2158 18.1498 27.3511 18.1775 27.4933C18.2052 27.6355 18.2031 27.7818 18.1716 27.9232C18.14 28.0646 18.0794 28.1983 17.9936 28.3162C17.9078 28.4341 17.7985 28.5337 17.6724 28.609C17.5462 28.6844 17.4057 28.7339 17.2594 28.7546C16.7196 28.8545 16.1743 28.9239 15.6263 28.9622C15.2601 28.9882 14.8795 29 14.511 29C12.2916 29.0024 10.1013 28.506 8.10853 27.5489C6.11577 26.5918 4.37367 25.1996 3.0163 23.4793C1.65893 21.759 0.722462 19.7566 0.278965 17.6261C-0.164532 15.4956 -0.103241 13.2938 0.458123 11.1901C1.01949 9.08649 2.06596 7.13705 3.51702 5.49183C4.96807 3.8466 6.78503 2.54946 8.82809 1.7002C10.8711 0.85094 13.0858 0.472209 15.3017 0.593148C17.5176 0.714087 19.6757 1.33147 21.6098 2.39779L21.3063 1.61899C21.242 1.47114 21.2089 1.3121 21.2089 1.15141C21.2089 0.990716 21.2419 0.831671 21.3061 0.683799C21.3703 0.535926 21.4643 0.402269 21.5825 0.290832C21.7007 0.179395 21.8406 0.0924701 21.9938 0.0352643C22.1471 -0.0219415 22.3106 -0.0482518 22.4745 -0.0420906C22.6384 -0.0359295 22.7993 0.00257628 22.9477 0.0711205C23.096 0.139665 23.2287 0.236837 23.3378 0.356818C23.4469 0.476799 23.5302 0.61712 23.5826 0.769377L24.7871 3.87281L24.7943 3.86809ZM12.2852 8.99407C12.2986 8.7109 12.4228 8.44366 12.6321 8.24791C12.8414 8.05215 13.1196 7.94292 13.4089 7.94292C13.6983 7.94292 13.9765 8.05215 14.1857 8.24791C14.395 8.44366 14.5193 8.7109 14.5326 8.99407V15.6942L19.213 17.712C19.3478 17.7703 19.4695 17.854 19.5712 17.9583C19.673 18.0627 19.7527 18.1856 19.806 18.3202C19.8592 18.4548 19.8849 18.5983 19.8815 18.7425C19.8781 18.8868 19.8458 19.029 19.7863 19.1611C19.7268 19.2931 19.6414 19.4123 19.5349 19.512C19.4284 19.6117 19.3029 19.6899 19.1655 19.742C19.0282 19.7942 18.8817 19.8193 18.7345 19.816C18.5872 19.8127 18.442 19.781 18.3073 19.7227L13.0078 17.443C12.7949 17.3631 12.6118 17.2217 12.4827 17.0375C12.3536 16.8533 12.2848 16.635 12.2852 16.4116V8.99407ZM20.6077 25.3136C20.3554 25.4529 20.1698 25.6847 20.0919 25.958C20.014 26.2313 20.0501 26.5237 20.1922 26.771C20.3343 27.0182 20.5709 27.2 20.8499 27.2763C21.1288 27.3527 21.4273 27.3173 21.6797 27.1781C22.3693 26.8026 23.0239 26.3682 23.6356 25.8801C23.7534 25.7938 23.8521 25.6851 23.926 25.5606C23.9999 25.4361 24.0474 25.2982 24.0657 25.1553C24.084 25.0124 24.0727 24.8673 24.0324 24.7288C23.9922 24.5902 23.9238 24.4611 23.8315 24.349C23.7391 24.2369 23.6247 24.1443 23.4949 24.0765C23.3652 24.0088 23.2228 23.9673 23.0764 23.9547C22.9299 23.9421 22.7824 23.9586 22.6425 24.0031C22.5027 24.0476 22.3735 24.1193 22.2626 24.2139C21.7452 24.6277 21.1915 24.9957 20.6077 25.3136ZM24.9123 21.3016C24.8364 21.4208 24.7852 21.5534 24.7616 21.692C24.738 21.8305 24.7425 21.9723 24.7748 22.1092C24.8071 22.246 24.8666 22.3753 24.95 22.4896C25.0333 22.6039 25.1388 22.7011 25.2604 22.7754C25.382 22.8498 25.5174 22.9 25.6588 22.9231C25.8003 22.9462 25.945 22.9418 26.0846 22.9102C26.2243 22.8785 26.3563 22.8202 26.473 22.7386C26.5897 22.6569 26.6888 22.5536 26.7647 22.4344C27.1822 21.7803 27.5455 21.0945 27.8511 20.3836C27.9135 20.2527 27.9483 20.1109 27.9533 19.9665C27.9584 19.8222 27.9336 19.6784 27.8805 19.5437C27.8273 19.409 27.7469 19.2862 27.6441 19.1827C27.5413 19.0792 27.4183 18.9971 27.2823 18.9414C27.1463 18.8857 27.0002 18.8575 26.8528 18.8585C26.7054 18.8595 26.5597 18.8896 26.4245 18.9472C26.2893 19.0048 26.1674 19.0885 26.0661 19.1934C25.9648 19.2983 25.8861 19.4221 25.8349 19.5575C25.5757 20.1622 25.2672 20.7455 24.9123 21.3016ZM26.784 15.7461C26.786 16.0139 26.8906 16.2712 27.077 16.4671C27.2634 16.663 27.518 16.7832 27.7905 16.8039C28.0631 16.8247 28.3336 16.7445 28.5487 16.5792C28.7637 16.4139 28.9076 16.1756 28.9519 15.9113C29.0146 15.1424 29.0146 14.3698 28.9519 13.6008C28.9548 13.4509 28.9255 13.302 28.8659 13.1639C28.8063 13.0257 28.7178 12.9013 28.606 12.7988C28.4943 12.6963 28.3618 12.6179 28.2172 12.5687C28.0726 12.5195 27.919 12.5006 27.7665 12.5133C27.614 12.5259 27.4658 12.5697 27.3317 12.642C27.1975 12.7143 27.0804 12.8133 26.9877 12.9327C26.8951 13.0521 26.8291 13.1893 26.794 13.3353C26.7589 13.4813 26.7555 13.6328 26.784 13.7802C26.837 14.4345 26.837 15.0918 26.784 15.7461Z"
									fill="#FF725E"
								/>
							</g>
							<defs>
								<clipPath id="clip0_1661_3117">
									<rect width={29} height={29} fill="white" />
								</clipPath>
							</defs>
						</svg>
						Climate Countdown
					</p>
					<p>
						<span>
							<CountUp
								start={loaded ? 0 : -1}
								end={Math.floor(yearLeft)}
								duration={2}
								enableScrollSpy={loaded}
								scrollSpyOnce={true}
							/>
						</span>{" "}
						<span className="last">Yrs</span>
					</p>
					<p>
						<span>
							<CountUp
								start={loaded ? 0 : -1}
								end={Math.floor((yearLeft % 1) * 365)}
								duration={2}
								enableScrollSpy={loaded}
								scrollSpyOnce={true}
							/>
						</span>{" "}
						<span className="last">Days</span>
					</p>
					<p>{currentTime}</p>
				</div>
				<p className="time_left_para">
					TIME LEFT TO LIMIT GLOBAL WARMING TO 1.5°C
				</p>
			</div>
			<div className={`header ${design_2 === true ? "design_2" : ""}`}>
				<Link rel="canonical" href="/" className="logo_a">
					<img src={logo.src} alt="logo" className="logo" />
				</Link>
				<div className="group pc">
					<div className="nav-links">
						<Link rel="canonical" href="/driver-partner">
							<div className="nav-link">Driver Partner</div>
						</Link>
						<Link rel="canonical" href="/vehicles">
							<div className="nav-link">Vehicles</div>
						</Link>
						<Link rel="canonical" href="/about-us">
							<div className="nav-link">About Us</div>
						</Link>
						<Link rel="canonical" href="/contact-us">
							<div className="nav-link">Contact Us</div>
						</Link>
					</div>
				</div>
				<div className="mobile">
					<svg
						onClick={() => {
							isDropdownOpened ? closeDropdown() : openDropdown();
						}}
						xmlns="http://www.w3.org/2000/svg"
						width="23"
						height="16"
						viewBox="0 0 23 16"
						fill="none"
					>
						<path
							d="M1 7.2373C0.613401 7.2373 0.3 7.5507 0.3 7.9373C0.3 8.3239 0.613401 8.6373 1 8.6373V7.2373ZM21.9974 8.6373C22.384 8.6373 22.6974 8.3239 22.6974 7.9373C22.6974 7.5507 22.384 7.2373 21.9974 7.2373V8.6373ZM1 13.8387C0.613401 13.8387 0.3 14.1521 0.3 14.5387C0.3 14.9253 0.613401 15.2387 1 15.2387V13.8387ZM21.9974 15.2387C22.384 15.2387 22.6974 14.9253 22.6974 14.5387C22.6974 14.1521 22.384 13.8387 21.9974 13.8387V15.2387ZM1 0.635938C0.613401 0.635938 0.3 0.949338 0.3 1.33594C0.3 1.72254 0.613401 2.03594 1 2.03594V0.635938ZM21.9974 2.03594C22.384 2.03594 22.6974 1.72254 22.6974 1.33594C22.6974 0.949338 22.384 0.635938 21.9974 0.635938V2.03594ZM1 8.6373H21.9974V7.2373H1V8.6373ZM1 15.2387H21.9974V13.8387H1V15.2387ZM1 2.03594H21.9974V0.635938H1V2.03594Z"
							fill="black"
						/>
					</svg>
				</div>
				<div className={`dropdown ${dropdownClasses}`}>
					<svg
						onClick={() => {
							closeDropdown();
						}}
						className="cross"
						xmlns="http://www.w3.org/2000/svg"
						width="11"
						height="11"
						viewBox="0 0 11 11"
						fill="none"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M1 10.2511L5.625 5.62783L1 10.2511ZM5.625 5.62676L10.2482 1L5.625 5.62676ZM5.625 5.62783L10.25 10.2511L5.625 5.62783ZM5.625 5.62676L1 1L5.625 5.62676Z"
							fill="white"
						/>
						<path
							d="M0.487099 9.73798C0.203723 10.0212 0.203636 10.4806 0.486903 10.764C0.770171 11.0473 1.22953 11.0474 1.5129 10.7642L0.487099 9.73798ZM6.1379 6.14093C6.42128 5.85766 6.42136 5.39831 6.1381 5.11493C5.85483 4.83156 5.39547 4.83147 5.1121 5.11474L6.1379 6.14093ZM5.11181 5.11396C4.82859 5.39739 4.82877 5.85674 5.1122 6.13996C5.39563 6.42317 5.85498 6.423 6.13819 6.13957L5.11181 5.11396ZM10.7614 1.5128C11.0446 1.22937 11.0445 0.770019 10.761 0.486806C10.4776 0.203592 10.0183 0.203767 9.73504 0.487196L10.7614 1.5128ZM6.1379 5.11474C5.85453 4.83147 5.39517 4.83156 5.1119 5.11493C4.82864 5.39831 4.82872 5.85766 5.1121 6.14093L6.1379 5.11474ZM9.7371 10.7642C10.0205 11.0474 10.4798 11.0473 10.7631 10.764C11.0464 10.4806 11.0463 10.0212 10.7629 9.73798L9.7371 10.7642ZM5.1119 6.13966C5.39517 6.42304 5.85453 6.42313 6.1379 6.13986C6.42128 5.85659 6.42136 5.39724 6.1381 5.11386L5.1119 6.13966ZM1.5131 0.487099C1.22983 0.203723 0.770474 0.203636 0.487099 0.486903C0.203723 0.770171 0.203636 1.22953 0.486903 1.5129L1.5131 0.487099ZM1.5129 10.7642L6.1379 6.14093L5.1121 5.11474L0.487099 9.73798L1.5129 10.7642ZM6.13819 6.13957L10.7614 1.5128L9.73504 0.487196L5.11181 5.11396L6.13819 6.13957ZM5.1121 6.14093L9.7371 10.7642L10.7629 9.73798L6.1379 5.11474L5.1121 6.14093ZM6.1381 5.11386L1.5131 0.487099L0.486903 1.5129L5.1119 6.13966L6.1381 5.11386Z"
							fill="white"
						/>
					</svg>
					<div className="navbar_as">
						<Link rel="canonical" href="/driver-partner">
							<div className="navbar_a">Driver Partner</div>
						</Link>
						<Link rel="canonical" href="/vehicles">
							<div className="navbar_a">Vehicles</div>
						</Link>
						<Link rel="canonical" href="/about-us">
							<div className="navbar_a">About Us</div>
						</Link>
						<Link rel="canonical" href="/contact-us">
							<div className="navbar_a">Contact Us</div>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default CustomHeader;
